import React from 'react'
import { Element } from 'domhandler/lib/node'
import { css } from 'linaria'
import { rem } from '~/utils/helper'
import { Query } from '~/types/graphql-types'

interface BlogcardProps {
  ogp: Query['ogp']
  element: Element
}

const blogcardStyle = css`
  display: flex;
  position: relative;
  overflow: hidden;
  border: 1px solid var(--color-background);
  border-radius: 8px;
  text-decoration: none;

  & > .content {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    padding: 16px;
    color: var(--color-text);
    line-height: 1.4;
    row-gap: 8px;
  }

  & > .content > .ogTitle {
    display: -webkit-box;
    overflow: hidden;
    font-size: ${rem(16)};
    font-weight: bold;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }

  & > .content > .ogDescription {
    display: -webkit-box;
    overflow: hidden;
    color: var(--color-text-sub);
    font-size: ${rem(12)};
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }

  & > .content > .hostname {
    color: var(--color-text-sub);
    font-size: ${rem(12)};
  }

  & > .ogImageWrapper {
    display: block;
    min-width: 30%;
    max-width: 30%;
    margin: 0;
  }

  & > .ogImageWrapper > .ogImage {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`

const BlogcardComponent = ({ ogp, element }: BlogcardProps) => {
  const { hostname } = new URL(element.attribs.href)
  const elementAttribs = element.attribs
  // Note: styleが残ってるとエラーになるため削除する
  delete elementAttribs.style
  return (
    <a className={blogcardStyle} {...elementAttribs}>
      <div className="content">
        <p className="ogTitle">{ogp?.ogTitle}</p>
        {ogp?.ogDescription && <p className="ogDescription">{ogp.ogDescription}</p>}
        <p className="hostname">{hostname}</p>
      </div>
      {ogp?.ogImage && (
        <figure className="ogImageWrapper">
          <img className="ogImage" src={ogp.ogImage} alt={ogp.ogTitle || ''} />
        </figure>
      )}
    </a>
  )
}

export default BlogcardComponent
